export function handleDropdownEvents() {
    $("body").on("click", ".js-dropdown-btn", function (e) {
        const $group = $(this).closest(".js-dropdown-group");

        let active = $group.is(".dropdown-group--active, .account-dropdown--active");

        $(".dropdown-group--active").removeClass("dropdown-group--active");
        $(".account-dropdown--active").removeClass("account-dropdown--active");
        if (!active) {
            if ($group.is(".dropdown-group")) {
                $group.addClass("dropdown-group--active");
            } else {
                $group.addClass("account-dropdown--active");
            }
        }

        e.stopPropagation();
        return false;
    }).on("click", () => {
        $(".dropdown-group--active").removeClass("dropdown-group--active");
        $(".account-dropdown--active").removeClass("account-dropdown--active");
    });
}
